import moment from 'moment-timezone';

const getHoursDiffBetweenTimeZones = (
	baseTimeZone: string,
	timeZone: string,
	dateIsoString: string = new Date().toISOString()
) => {
	const baseMoment = moment.tz(dateIsoString, baseTimeZone);
	const targetMoment = moment.tz(dateIsoString, timeZone);

	return (targetMoment.utcOffset() - baseMoment.utcOffset()) / 60;
};

const getStringHoursDiffBetweenTimeZones = (baseTimeZone: string, timeZone: string, dateIsoString?: string) => {
	const hoursDiff = getHoursDiffBetweenTimeZones(baseTimeZone, timeZone, dateIsoString);
	return `${hoursDiff < 0 ? '-' : '+'}${Math.abs(hoursDiff)}`;
};

const getTimeZoneAbbreviation = (timeZone: string, timestamp = Date.now()) => {
	const timeZoneObject = moment.tz.zone(timeZone);
	return timeZoneObject ? timeZoneObject.abbr(timestamp) : timeZone;
};

// Anchors a calendar date (YYYY-MM-DD) to a UTC start/end-of-day ISO boundary, for filtering
// date-only values stored as naive UTC midnight without drifting by the viewer's timezone.
const toUtcDayBoundary = (calendarDate: string, edge: 'start' | 'end'): string => {
	const utcDay = moment.utc(calendarDate, 'YYYY-MM-DD');

	return (edge === 'start' ? utcDay.startOf('day') : utcDay.endOf('day')).toISOString();
};

export const timeZoneUtils = {
	getStringHoursDiffBetweenTimeZones,
	getTimeZoneAbbreviation,
	toUtcDayBoundary
};
